import React, { useState } from 'react'
import ReturnHeader from '../../components/returnHeader'
import { successUpload, tutorIcons, uploadFile } from '../../assets'
import FileType from '../../components/portfolioComps/file'
import {Modal, GlobalInput, FileInput} from '../../components/Generic'
import { Link } from 'react-router-dom'

const Portfolio = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // modal opener
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // video, image opener
 
  return (
    <div>
        <ReturnHeader page={'Portfolio'} first={'Log out'} second={'Adminga yozish'} icon={tutorIcons.admin}/>
        <div className='mt-[100px]'>
          <Link to='/about'>
        <FileType  text={'About Teacher'} fileType={'pdf'}/>
          </Link>
          <Link to='/about'>
        <FileType text={'Yutuqlari'} fileType={'files'}/>
          </Link>
          <Link to='/about'>
        <FileType downloads={true} text={'Kasbiga oid videolar'} fileType={'video'} />
          </Link>
          <Link to='/about'>
        <FileType  text={'Kasbiga oid malumot'} fileType={'img'} />
          </Link>
        <Modal isOpen={isModalOpen} onClose={closeModal} modalName={'Upload portfolio'} >
          <div className='box-border flex flex-col w-full px-[20px] pb-[24px] pt-[7px] justify-center items-center'>
            <FileInput>
              <div className='flex justify-center items-center flex-col'>
            <img className='cursor-pointer w-[50px] h-[42px] pb-[10px]' src={uploadFile} alt="" />
            <div className='cursor-pointer mb-[10px] text-blue-chatBlue text-[15px] font-sans'>Select file from storage</div>
              </div>
            </FileInput>
          <GlobalInput value={'Add title'}/>
          </div>
          <div className=' flex flex-col w-full px-[20px] pb-[24px] pt-[7px] justify-center items-center'>
            <img className='cursor-default w-[50px] h-[50px] pb-[0px]' src={successUpload} alt="" />
            <div className='cursor-default mb-[5px] text-gray-lightGray text-[9px] sm:text-[12px]'>About me.pdf</div>
            <div className='cursor-pointer mb-[10px] text-blue-chatBlue text-[15px] font-sans'>Select file from storage</div>
          </div>
        </Modal >
        <div onClick={openModal} className='p-[10px] text-white w-[280px] flex justify-center cursor-pointer transition-all hover:shadow-sideShadow items-center bg-gray-lightGray bg-red text-red'>Open Upload Modal (Temporary)</div>
        </div>
    </div>
  )
}

export default Portfolio